export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "regexTester": {
    "title": "Regex Tester",
    "subtitle": "Test regular expressions in real-time. Match, highlight, and copy. ",
    "privacy": "100% client-side",
    "quickPatterns": "Quick Patterns",
    "pattern": "Pattern",
    "patternPlaceholder": "Enter regex pattern...",
    "flags": "Flags",
    "testText": "Test Text",
    "testPlaceholder": "Enter text to test against...",
    "matches": "matches",
    "match": "Match",
    "index": "Index",
    "length": "Length",
    "groups": "Groups",
    "noMatches": "No matches found"
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 All regex testing happens locally in your browser. Your patterns and test strings are never uploaded to any server."
    },
    "guide": {
      "title": "How to Use Regex Tester",
      "description": "Test regular expressions in real-time with match highlighting, group extraction, and replace preview.",
      "steps": [
        {
          "title": "Enter your regex pattern",
          "description": "Type your regular expression into the pattern field. Use the flags dropdown to set global, case-insensitive, multiline, and dot-all modes."
        },
        {
          "title": "Add test text",
          "description": "Paste or type the text you want to test against in the input panel. Matches are highlighted in real-time as you type."
        },
        {
          "title": "Review matches and groups",
          "description": "Inspect each match, captured groups, and match positions. Use the replace tab to preview substitution results before applying them."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "Real-time regex matching with syntax highlighting",
        "Support for all standard JavaScript regex flags",
        "Captured group extraction and display",
        "Match position and length information",
        "Replace preview with substitution results",
        "100% client-side processing — zero data upload"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Is my regex data sent to a server?",
          "answer": "No. All pattern matching happens entirely within your browser using the native JavaScript RegExp engine. Your patterns and test strings never leave your device."
        },
        {
          "question": "What regex flavor is used?",
          "answer": "The tester uses the standard JavaScript RegExp engine (ECMAScript). This matches the behavior of regex in Node.js, Chrome, Firefox, and Safari."
        },
        {
          "question": "Why does my regex show no matches?",
          "answer": "Common issues include missing flags (e.g., case-sensitive matching when you need /i), unescaped special characters, or incorrect anchoring (^ and $). Check the syntax reference for help."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Cron Parser",
          "url": "/developer/cron-parser",
          "description": "Parse standard cron expressions into human-readable schedules."
        },
        {
          "name": "JSON Formatter",
          "url": "/formatter/json-formatter",
          "description": "Format, validate, and beautify JSON data with syntax highlighting."
        },
        {
          "name": "Case Converter",
          "url": "/text/case-converter",
          "description": "Convert text between uppercase, lowercase, camelCase, snake_case, and more."
        }
      ]
    }
  }
};
